import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import styles from './BlacklistSearch.module.css';

export default class BlacklistSearch extends React.Component {
  static propTypes = {
    onSearch: PropTypes.func.isRequired,
  };

  state = {
    email: '',
  };

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleSearch = () => {
    const { email } = this.state;
    this.props.onSearch(email.trim());
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleSearch();
    }
  };

  render() {
    const { email } = this.state;

    return (
      <div className={styles.searchBar}>
        <div className={styles.searchRow}>
          <TextField
            id="blacklistEmailInput"
            className={styles.searchInput}
            placeholder="Email"
            type="search"
            value={email}
            onChange={this.handleEmailChange}
            onKeyPress={this.handleKeyPress}
          />
        </div>
        <div className={styles.actionsRow}>
          <Button
            id="searchButton"
            variant="contained"
            color="primary"
            onClick={this.handleSearch}>
            Search
          </Button>
        </div>
      </div>
    );
  }
}
